const FETCH_STAR_EVENT = 'consume/FETCH_STAR_EVENT';

const FETCH_STAR_EVENT_DASHBOARD = 'consume/FETCH_STAR_EVENT_DASHBOARD';

const POST_STAR_EVENT_REWARD = 'consume/POST_STAR_EVENT_REWARD';

export default {
  FETCH_STAR_EVENT,
  FETCH_STAR_EVENT_DASHBOARD,
  POST_STAR_EVENT_REWARD,
};



// WEBPACK FOOTER //
// ./src/app/redux/events/consume/types.js